// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e9e9b75","239":"14223832","453":"99dcf01f","732":"fa542fc9"}[chunkId] + ".chunk.js";
};